import PropTypes from 'prop-types';
import ArticleActionAnchor from '../articleActionAnchor';
import Icon from '../../icon';
import { createArticleLink } from '../../../utils/linkCreator';
import { DoiArticleEventsPropTypes } from '../../../utils/trackers/createArticleEvents';
import { trackAdobeEvent } from '../../../utils/trackers/adobe';

export default function ViewAtPublisherAnchor({ doi, id, viewAtPublisherEventData }) {
  const onClick = () => {
    if (viewAtPublisherEventData) {
      trackAdobeEvent('navigationClick', viewAtPublisherEventData);
    }
  };

  return (
    <ArticleActionAnchor
      icon={<Icon.LogOut height={18} />}
      href={createArticleLink({ doi })}
      id={id}
      label="View at Publisher"
      onClick={onClick}
    />
  );
}

ViewAtPublisherAnchor.propTypes = {
  doi: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  viewAtPublisherEventData: DoiArticleEventsPropTypes.viewAtPublisher,
};

ViewAtPublisherAnchor.defaultProps = {
  viewAtPublisherEventData: undefined,
};
